// Social networks the back office can store a link for: [settings key, label, Font Awesome icon classes].
export const NETWORKS = [
  ['facebook', 'Facebook', 'fa-brands fa-facebook-f'],
  ['instagram', 'Instagram', 'fa-brands fa-instagram'],
  ['youtube', 'YouTube', 'fa-brands fa-youtube'],
  ['tiktok', 'TikTok', 'fa-brands fa-tiktok'],
  ['linkedin', 'LinkedIn', 'fa-brands fa-linkedin-in'],
];
